const SET_LOTTERY_LIST = "app/lottery/SET_LOTTERY_LIST";

function setCampDataLotteryList(data) {
    return {
        type: SET_LOTTERY_LIST,
        payload: {
            items: data
        }
    }
}

export {
    SET_LOTTERY_LIST,
    setCampDataLotteryList
}